export enum AccountingRoute {
  empty = '',
  balances = 'balances',
  movements = 'movements',
  journals = 'journals',
  annualAccounts = 'annual-accounts'
}
